module.exports = __webpack_public_path__ + "img/check.116d9c9a.svg";